import TipoVendaModel from "@/models/tipoVendaModel";
import { TipoVendaOption } from "@/types/options";

import { iServiceCached } from "./base/iServiceCached";

class TipoVendaService extends iServiceCached<TipoVendaModel> {
    constructor() {
        super("TipoVenda");
    }

    public async comboCached(franquiaId: number): Promise<TipoVendaOption[]> {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id!,
            text: p.descricao,
            utilizaValorCusto: p.utilizaValorCusto,
            emiteNFe: p.emiteNFe,
            emiteNFSe: p.emiteNFSe,
            permiteControlados: p.permiteControlados,
            permiteNFeSemFaturamento: p.permiteNFeSemFaturamento,
            permiteNFSeSemFaturamento: p.permiteNFSeSemFaturamento,
            permiteNFCeSemFaturamento: p.permiteNFCeSemFaturamento,
            tiposClientesPermitidos: p.tiposClientesPermitidos ?? [],
            naturezaOperacaoDentroEstadoId: p.naturezaOperacaoDentroEstadoId,
            naturezaOperacaoForaEstadoId: p.naturezaOperacaoForaEstadoId,
            tipoVendaGrupoAtlas: p.tipoVendaGrupoAtlas,
        }));
    }
}

export default new TipoVendaService();
